import { z } from 'zod';
import { PasswordSchema, UserEmailSchema } from './ReusableValidation';

export const ChangePasswordSchema = z
  .object({
    currentPassword: z.string().nonempty('Current password is required'),
    newPassword: PasswordSchema,
    confirmPassword: z.string().nonempty('Confirmation password is required'),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Passwords doesn't match",
    path: ['confirmPassword'],
  });

export const CreateUserSchema = z.object({
  username: z
      .string()
      .nonempty('Username is required')
      .min(3, 'Username must be at least 3 characters.'),
  email: UserEmailSchema,
  password: PasswordSchema,
  role: z
    .string()
    .nonempty('Role is required.'),
  organization: z
  .string().nullable(),
  }).superRefine((data, ctx) => {
    const { role, organization, projects } = data;
    console.log(data);

    if (role !== '1' && !organization) {
      ctx.addIssue({
        path: ['organization'],
        message: 'Organization is required.',
      });
    }
});

// Define validation schema using Zod
export const LoginSchema = z.object({
    email: UserEmailSchema,
    password: z
        .string()
        .nonempty('Password is required'),
});

export const ResetPasswordSchema = z.object({
  newPassword: PasswordSchema,
  confirmPassword: z.string().min(8, { message: "Confirm Password must be at least 8 characters long" }),
}).superRefine((data, ctx) => {
  if (data.confirmPassword !== data.newPassword) {
    ctx.addIssue({
      path: ['confirmPassword'],
      message: "Passwords don't match",
    });
  }
});
  